import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from '@app/app-routing.module';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { ButtonModule } from 'primeng/button';
import { ChipModule } from 'primeng/chip';
import { CommonModule } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CoreModule } from '@app/core/core.module';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { DsGovDirectivesModule } from '@sigepe/dsgov-theme';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgModule } from '@angular/core';
import { PesquisarCestaCurriculoComponent } from './pesquisar-cesta-curriculo/pesquisar-cesta-curriculo.component';
import { ResultadoCestaCurriculoComponent } from './resultado-cesta-curriculo/resultado-cesta-curriculo.component';
import { SharedModule } from '@app/shared/shared.module';
import { SigepeSegurancaModule } from '@sigepe/ngx-sigepe-seguranca';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { environment } from '@environments/environment';

@NgModule({
	declarations: [PesquisarCestaCurriculoComponent, ResultadoCestaCurriculoComponent],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		AppRoutingModule,
		CoreModule,
		SharedModule,
		BrowserModule,
		BrowserAnimationsModule,
		AutoCompleteModule,
		ButtonModule,
		ConfirmDialogModule,
		DataViewModule,
		DialogModule,
		DropdownModule,
		MessageModule,
		MessagesModule,
		MultiSelectModule,
		SharedModule,
		SigepeSegurancaModule.forRoot(environment.SEGURANCA_CONFIG),
		TableModule,
		SkeletonModule,
		ChipModule,
		TagModule,
		DsGovDirectivesModule
	]
})
export class CestaCurriculoModule {}
